import { useAtomValue } from "jotai";
import { useIsGenieEnabled } from "@/lib/genie/useIsGenieEnabled";
import { collapsedForGenieAtom, pinnedCollapsibleAtom } from "./atoms";

// Whether the sidenav collapses to a rail: pinned so, or collapsed by Genie
// where Genie can show (not in a deployed app, not with its flag off), so a
// collapse Genie made is not left behind where Genie is gone.
export const useIsSidenavCollapsible = (): boolean => {
  const pinned = useAtomValue(pinnedCollapsibleAtom);
  const collapsedForGenie = useAtomValue(collapsedForGenieAtom);
  const genieEnabled = useIsGenieEnabled();
  return pinned || (collapsedForGenie && genieEnabled);
};
